export const colourPalette = {
  primary: {
    white: '#ffffff',
    black: '#000000',
    green: '#bdd755',
    pattern:
      'linear-gradient(45deg, rgb(34, 193, 195), rgb(253, 187, 45), rgb(144, 19, 254))',
  },
  secondary: {
    lightGreen: '#dfece2',
    darkHeritageGreen: '#005640',
  },
  tertiary: {
    winterGreen: '#627786',
    winterGreen20: '#e0e4e7',
    darkGrey: '#222222',
    accessibilityGrey: '#707070',
    mediumGrey: '#949494',
    lightGrey: '#cccccc',
    backgroundGrey: '#f5f5f5',
    backgroundPink: '#fbf6f4',
  },
  functional: {
    successGreenBackground: '#f4faed',
    errorRedBackground: '#fff3f4',
    infoBlueBackground: '#eaf0f3',
    successGreen: '#2db236',
    errorRed: '#ea122a',
    infoBlue: '#1e5a7a',
    focusBlue: '#4273b7',
    reviewGreen: '#6fb06f',
  },
  offerAndSale: {
    foodBlack: '#000000',
    goldOnDark: '#a98b52',
    goldOnLight: '#bd9954',
    saleRed: '#a6192e',
    offerYellow: '#f9c606',
    dineInYellow: '#efdf00',
    newAndImprovedFit: '#e86c25',
    charityPink: '#ff9999',
  },
  sparks: {
    sparksGreen: '#43d68a',
    sparksDark: '#222222',
  },
  buttonHoverStyles: {
    primaryHover: '#b4cc51',
    secondaryHover: '#4e5f6b',
    tertiaryHover: '#e6e6e6',
  },
};
